import SelectField, { SelectFieldProps } from '@sprinx/react-mui-fields/SelectField';
import SelectFieldItem from '@sprinx/react-mui-fields/SelectFieldItem';
import React from 'react';

export type CustomerProfilePageSubsidiarySupervisorSelectorProps = SelectFieldProps<string> & {
  contactId: string;
  supervisors: {
    email: string;
    id: string;
    name: string;
  }[];
};

const CustomerProfilePageSubsidiarySupervisorSelector: React.FC<
  CustomerProfilePageSubsidiarySupervisorSelectorProps
> = ({ contactId, supervisors, value, ...rest }) => {
  return (
    <SelectField {...rest} value={value}>
      {supervisors.map(({ id, name, email }) => (
        <SelectFieldItem key={id} value={id}>
          {name} ({email})
        </SelectFieldItem>
      ))}
    </SelectField>
  );
};

export default CustomerProfilePageSubsidiarySupervisorSelector;
